"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mostFrequentValuesInArrayOfDictionaries = void 0;
function mostFrequentValue(arr) {
    if (arr.length === 0) {
        return null; // Return null for an empty array
    }
    var frequencyMap = {};
    // Count occurrences of each element in the array
    arr.forEach(function (element) {
        var key = String(element);
        frequencyMap[key] = (frequencyMap[key] || 0) + 1;
    });
    var mostFrequent = arr[0]; // Assume the first element is the most frequent
    var highestFrequency = 1; // Frequency of the assumed most frequent element
    // Find the element with the highest frequency
    Object.keys(frequencyMap).forEach(function (key) {
        if (frequencyMap[key] > highestFrequency) {
            mostFrequent = key;
            highestFrequency = frequencyMap[key];
        }
    });
    return mostFrequent;
}
function mostFrequentValuesInArrayOfDictionaries(arr, keys) {
    var result = {};
    keys.forEach(function (key) {
        var valuesForKey = arr.map(function (obj) { return (key in obj ? obj[key] : undefined); }).filter(function (val) { return val !== undefined; });
        var mostFrequentValueForKey = mostFrequentValue(valuesForKey);
        if (mostFrequentValueForKey)
            result[key] = mostFrequentValueForKey;
    });
    return result;
}
exports.mostFrequentValuesInArrayOfDictionaries = mostFrequentValuesInArrayOfDictionaries;
//# sourceMappingURL=getMostFrequent.js.map